import { useVfm } from 'vue-final-modal'

function useModal(){
  const vfm = useVfm()
  const {
    modals,
    openedModals,
    get,
    open,
    close,
    closeAll
  } = vfm
  function openModal(modalName: string, params: unknown) {
    try {
      const modalInstance: any = get(modalName)
      if (!modalInstance) {
        throw new Error(`modal not found`)
      }
      return modalInstance.parent.exposed.init(params)
    } catch (e: any) {
      console.warn(`error opening modal "${modalName}": `, e.message)
      return Promise.reject('open error')
    }
  }
  return {
    openModal,
    open,
    modals,
    openedModals,
    get,
    close,
    closeAll 
  }
}

export {useModal}